import React from "react";
import "./latestcontent.style.css";
import YouTube from "react-youtube";

const LatestContent = ({ content }) => {
  return (
    <article
      className="latest-video-container"
      itemScope
      itemType="https://schema.org/VideoObject"
    >
      {/* Invisible structured metadata */}
      <meta itemProp="name" content={content.title} />
      <meta itemProp="description" content={content.desc} />
      <meta
        itemProp="embedUrl"
        content={`https://www.youtube.com/embed/${content.id}`}
      />

      <div className="left-section">
        {/* Keep text same, semantic level corrected */}
        <h3 className="section-title">LATEST VIDEO</h3>

        <h4 className="section-subtitle" itemProp="name">
          {content.title}
        </h4>

        <p className="section-desc" itemProp="description">
          {content.desc}
        </p>
      </div>

      <div className="right-section">
        <YouTube
          className="video"
          videoId={content.id}
          title={`${content.title} | Swagat Vyas`}
          opts={{
            width: "100%",
            height: "300",
            playerVars: {
              rel: 0,
              modestbranding: 1,
            },
          }}
        />
      </div>
    </article>
  );
};

export default LatestContent;
